import { render, staticRenderFns } from "./DocumentWithSectionsHistorical.vue?vue&type=template&id=19c698c4&scoped=true"
import script from "./DocumentWithSectionsHistorical.vue?vue&type=script&lang=js"
export * from "./DocumentWithSectionsHistorical.vue?vue&type=script&lang=js"
import style0 from "./DocumentWithSectionsHistorical.vue?vue&type=style&index=0&id=19c698c4&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c698c4",
  null
  
)

export default component.exports